export default __webpack_public_path__ + "static/media/bhd-star-59k-ve-ca-tuan-16045660915386.e724f887.jpg";